<template lang="html">
  <md-card class="cardCreateStory">
    <md-card-content>
      <create-form @newChapter="newChapter" @newPlace="newPlace" :place="place || Place"/>

      <submit :chapter="Chapter" :place="place || Place" />

    </md-card-content>
  </md-card>
</template>

<script>
import createForm from "./create/form";
import submit from "./create/submit";

export default {
  name: "createChapter",
  props: ['place'],
  components: {
    createForm,
    submit,
  },
  data: function() {
    return {
      Chapter: null,
      Place: null
    };
  },
  methods: {
    newChapter(chap) {
      this.Chapter = chap;
    },
    newPlace(place) {
      this.Place = place;
    }
  },
};
</script>

<style scoped>
.cardCreateStory {
  position: relative;
  top: 0;
  width: 100%;
  margin: 0;
  padding-top: 2em;
}
</style>
